import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import * as moment from 'moment';
import { PromotionsService } from '../../promotions.service';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-addpromotion',
  templateUrl: './addpromotion.component.html',
  styleUrls: ['./addpromotion.component.scss']
})
export class AddpromotionComponent extends FeaturesBaseComponent implements OnInit{

  bannerPromoForm: FormGroup;
  today = new Date();

  addVideo = this.fb.group({

    videoLink: new FormControl('', [Validators.required]),
    status: new FormControl('', Validators.required),
    createdDate: new FormControl('', Validators.required)

  })

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private promotionService: PromotionsService,
    public dialog: MatDialog,
    private router: Router,
  ) {    super(); }



  ngOnInit(): void {
    super.ngOnInit();
    this.initbannerPromoForm();
  }

  initbannerPromoForm(){
    this.bannerPromoForm = new FormGroup({
      headerName: new FormControl('', [Validators.required]),
      videoUrl: new FormControl('', [Validators.required, this.youtubeUrlValidator]),
      status: new FormControl('Active',[Validators.required]),
      language: new FormControl('English',[Validators.required]),
      promotionCreatdttm:new FormControl('',[Validators.required]),

    })
  }

  youtubeUrlValidator(control: FormControl) {
    const url = control.value;
    if (url && !url.startsWith("https://youtu.be/")) {
      return { invalidUrl: true };
    }
    return null; // Return null if the URL is valid
  }

  get f(){
    return this.bannerPromoForm.controls;
  }

  ngOnDestroy():void{
    super.ngOnDestroy()
  }
  onBannerFormSubmit(e){
    if (this.bannerPromoForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.bannerPromoForm)
        }else{
          this.router.navigate(['features/promotions/video-config'])
        }
      });

    }
  }
  setSubmitParameters(bannerPromoForm: FormGroup){  
    let httpParams: Params = {
      headerName: bannerPromoForm.get('headerName').value,
      videoUrl: bannerPromoForm.get('videoUrl').value,
      status: bannerPromoForm.get('status').value,
      language: bannerPromoForm.get('language').value,
      promotionCreatdttm: moment(bannerPromoForm.get('promotionCreatdttm').value).format('MM-DD-YYYY'),
      
    }
    this.promotionService.addVideoInstruction(httpParams).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.router.navigate(['features/promotions/video-config'])
            this.toastrService.success('Video added successfully', 'Success', {
              timeOut: 3000,
            });        
        }
        }

      }
    );
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/promotions/video-config')
      }
    });
  }
  onCheckCertify(e){
  }
  checkSubmitDisplayed() {
    return !(this.bannerPromoForm.valid); 
  }
}
